import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const PricePage = () => (
  <Layout>
    <SEO title="harga pembuatan website gatsby js" />
    <div class="masthead-followup row m-0">
    <div class="col-12 col-md-12 p-3 p-md-5 bg-primary text-white text-center">
    <h1><a href="/price" title="harga pembuatan website gatsby JS" class="text-white">DAFTAR HARGA WEBSITE ART SERVICES</a></h1>
    <p>Bersiaplah menjadi gatsby warrior dan pimpin dunia website mu.</p>
    <img alt="pembuatan website modern keren gatsby js" class="img-fluid" src="./static/img/gatsby warior.png"/>
    <img alt="pembuatan website modern keren gatsby js" class="img-fluid" width="100%" src="./static/img/Gatsby_Logo_White.png"/>
    <p>Pilih paket website desain dan art services sesuai dengan price list dibawah ini.</p>
    </div>
    <div class="col-12 col-md-4 p-3 p-md-5 bg-light border boder-primary text-center">
<h3 class="bg-dark text-white p-3 md-5">WEB DESIGN</h3>
<ul class="text-left">
    <li>Gatsby JS web</li>
    <li>3 Editing Foto</li>
    <li>1 Video Promosi</li>
    <li>Free Domain</li>
    <li>Free Hosting</li>
</ul>
<p class="border">Rp.1.500.000/<small><small>years</small></small></p>
        </div>
        <div class="col-12 col-md-4 p-3 p-md-5 bg-light border boder-primary text-center">
        <h3 class="bg-dark text-white p-3 md-5">PHOTOSHOP</h3>
<ul class="text-left">
    <li>Editing Foto</li>
    <li>Retouching</li>
    <li>Colouring</li>
    <li>Digital ART</li>
    <li>Manipulation</li>
</ul>
<p class="border">Rp.300.000/<small><small>Photo</small></small></p>
        </div>
        <div class="col-12 col-md-4 p-3 p-md-5 bg-light border boder-primary text-center">
        <h3 class="bg-dark text-white p-3 md-5">VIDEO</h3>
        <ul class="text-left">
    <li>Editing Video</li>
    <li>Cinematic</li>
    <li>Animasi</li>
    <li>Promosi</li>
    <li>White Board</li>
</ul>
<p class="border">Rp.500.000/<small><small>Video</small></small></p>
</div>
<div class="col-12 col-md-8 p-3 p-md-5 bg-light border boder-primary text-center">
<h3 class="bg-dark text-white p-3 md-5">UPDATE WEB PRICE</h3>
<ul class="text-left">
    <li>Update new post page Rp.100.000/Post</li>
    <li>Update new post page + desain Rp.300.000/Post</li>
    <li>Update new Website info Rp.300.000/Update</li>
</ul>
        </div>
        <div class="col-12 col-md-4 p-3 p-md-5 bg-light border boder-primary text-center">
<h3 class="bg-dark text-white p-3 md-5">PAYMENT ORDER</h3>
<ul class="text-left">
    <li>BCA BANK</li>
    <li>0181884109</li>
    <li>Suci Chanifah</li>
</ul>
        </div>
        <div class="col-12 col-md-12 p-3 p-md-5 bg-primary text-white text-center">
        <p>Hubungi kami click icon dibawah ini.</p>
<a href="https://wa.me/6285646104747" title="Chat va whatsapp" target="blank"><img width="80" alt="contact pembuatan website company profile" class="img-fluid" src="./static/img/pembuatan web modern gastby js (42).png"/></a>
<a href="tel:+6285331361404" title="Call kami" target="blank"><img width="80" alt="contact pembuatan website company profile" class="img-fluid" src="./static/img/pembuatan web modern gastby js (39).png"/></a>
<a href="mailto:hockeycorpmarketing@gmail.com" title="Kirim email" target="blank"><img width="80" alt="contact pembuatan website company profile" class="img-fluid" src="./static/img/pembuatan web modern gastby js (34).png"/></a>
<br/><br/><Link class="btn btn-lg btn-light" to="/">Home Page</Link>
            </div>
       </div>
  </Layout>
)

export default PricePage
